import { Node } from '@tiptap/core'
import { VueNodeViewRenderer, mergeAttributes } from "@tiptap/vue-3"
import View from "./View.vue"

export default Node.create({
  name: 'Panel',

  group: 'block',

  content: 'block*',

  draggable: true,

  isolating: true,

  addAttributes() {
    return {
      topMargin: {
        default: true
      },
    }
  },

  parseHTML() {
    return [
      {
        tag: 'div[data-type="panel"]',
      },
    ]
  },

  renderHTML({ node, HTMLAttributes }) {
    return ['div', mergeAttributes(HTMLAttributes, {
      'data-type': 'panel',
      class: 'bg-white shadow rounded p-4' + (node.attrs.topMargin ? ' mt-6' : '')
    }), 0]
  },

  addNodeView() {
    return VueNodeViewRenderer(View)
  }
})
